import onKeyboardForward from '../actions/onKeyboardForward';
import getInstrumentationContextsFromTableView from 'owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView';
import { getItemClientId } from 'owa-mail-list-table-operations/lib/actions/store-factory/mapItemTypeToItemRelation';
import forwardConversation from 'owa-mail-message-actions/lib/actions/forwardConversation';
import forwardItem from 'owa-mail-message-actions/lib/actions/forwardItem';
import { getItemToShowFromNodeId } from 'owa-mail-store/lib/utils/conversationsUtils';
import shouldShowUnstackedReadingPane from 'owa-mail-store/lib/utils/shouldShowUnstackedReadingPane';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { orchestrator } from 'satcheljs';
import {
    shouldSuppressServerMarkReadOnReplyOrForward,
    TableQueryType,
    MailRowDataPropertyGetter,
} from 'owa-mail-list-store';

// Orchestrator for keyboard forward on both item parts and rows
export default orchestrator(onKeyboardForward, actionMessage => {
    const { tableView, selectedNodeIds, selectedRowKeys } = actionMessage;
    const suppressServerMarkReadOnReplyOrForward = shouldSuppressServerMarkReadOnReplyOrForward(
        tableView
    );

    // Item part operation
    if (selectedNodeIds.length > 0) {
        // Only support forward to a single item.
        // If it's multi selected, take no action
        if (selectedNodeIds.length !== 1) {
            return;
        }
        const item = getItemToShowFromNodeId(selectedNodeIds[0]);
        const clientItemId = getItemClientId(item, tableView);
        forwardItem(
            clientItemId,
            'Keyboard',
            null /* instrumentationContexts */,
            suppressServerMarkReadOnReplyOrForward
        );
        // Row key operation
    } else {
        // Only support forward a single row.
        // If it's multi selected, take no action
        if (selectedRowKeys.length !== 1) {
            return;
        }

        const rowId = MailRowDataPropertyGetter.getRowIdToShowInReadingPane(
            selectedRowKeys[0],
            tableView
        );
        let instrumentationContexts;
        if (tableView.tableQuery.type == TableQueryType.Search) {
            instrumentationContexts = getInstrumentationContextsFromTableView(
                [selectedRowKeys[0]],
                tableView
            );
        }
        const listViewType = tableView.tableQuery.listViewType;
        if (listViewType === ReactListViewType.Message || shouldShowUnstackedReadingPane()) {
            forwardItem(
                rowId,
                'Keyboard',
                instrumentationContexts,
                suppressServerMarkReadOnReplyOrForward
            );
        } else if (listViewType === ReactListViewType.Conversation) {
            forwardConversation(
                rowId,
                'Keyboard',
                instrumentationContexts,
                suppressServerMarkReadOnReplyOrForward
            );
        }
    }
});
